// extracted by mini-css-extract-plugin
module.exports = {"link":"language-nav_link__IXV8h","element":"language-nav_element__1kqGB"};